<script setup>
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({name: "SkeletonLoader"});

  defineProps({
    classNames: {
      type: String,
      default: "",
    },
  });
</script>

<template>
  <div :class="cn('animate-pulse rounded-xl bg-gray-300 print:hidden', classNames, $attrs.class)" />
</template>
